export default __webpack_public_path__ + "static/media/pexels-cottonbro-7579834.e334b2a8.e334b2a8.jpg";